import React, { useState } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { portalApi } from "@/lib/portalApi";
import { usePortalAuth } from "@/portal/PortalAuth";

export default function PortalOtpPage() {
  const { isAuthenticated, loading, setUser } = usePortalAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email;
  const [code, setCode] = useState("");
  const [trustDevice, setTrustDevice] = useState(true);
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (!loading && isAuthenticated) return <Navigate to="/portal" replace />;
  if (!email) return <Navigate to="/portal/login" replace />;

  async function onSubmit(e) {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      const data = await portalApi.verifyOtp({ code, trust_device: trustDevice });
      setUser(data.user);
      navigate("/portal");
    } catch (err) {
      setError(err.message || "Invalid code.");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="portal-shell--auth">
      <form className="portal-form portal-form--auth" onSubmit={onSubmit}>
        <p className="eyebrow" style={{ color: "rgba(255,255,255,0.45)" }}>
          Verification
        </p>
        <h1 style={{ fontFamily: "var(--font-display)", letterSpacing: "-0.04em", marginBottom: "0.35rem" }}>Enter code</h1>
        <p style={{ color: "rgba(255,255,255,0.55)", marginBottom: "1rem", fontSize: "0.92rem" }}>
          We sent a 6-digit code to {email}.
        </p>
        {error && <div className="portal-alert portal-alert--error">{error}</div>}
        <label>
          One-time code
          <input
            inputMode="numeric"
            autoComplete="one-time-code"
            pattern="[0-9]{6}"
            maxLength={6}
            required
            value={code}
            onChange={(e) => setCode(e.target.value.replace(/\D/g, "").slice(0, 6))}
          />
        </label>
        <label style={{ display: "flex", alignItems: "center", gap: "0.5rem", fontWeight: 500 }}>
          <input type="checkbox" checked={trustDevice} onChange={(e) => setTrustDevice(e.target.checked)} />
          Trust this device for 30 days
        </label>
        <div className="portal-actions">
          <button className="btn" type="submit" disabled={submitting || code.length !== 6}>
            {submitting ? "Verifying…" : "Verify"}
          </button>
          <Link className="btn btn--ghost" to="/portal/login" style={{ color: "inherit", borderColor: "rgba(255,255,255,0.35)" }}>
            Back
          </Link>
        </div>
      </form>
    </div>
  );
}
